import { render, staticRenderFns } from "./AdminActividad.vue?vue&type=template&id=5a796df8&"
import script from "./AdminActividad.vue?vue&type=script&lang=js&"
export * from "./AdminActividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports